
import { StateSlice } from '@/stores/appStore';
// import { toast } from 'react-hot-toast';

const namespace = 'runtime';
export type RuntimeSlice = {
  [namespace]: {
    sidebar: {
      collapsed: boolean;
      setCollapsed: (collapsed: boolean) => void;
    };
  }
};

export const createRuntimeSlice: StateSlice<RuntimeSlice> = ((set, _get) => {
  const get = () => _get()[namespace];
  return {
    [namespace]: {
      sidebar: {
        collapsed: false,
        setCollapsed: (collapsed) => {
          set(({ [namespace]: state }) => {
            state.sidebar.collapsed = collapsed;
          });
        },
      },
    },
  };
});
